/* unplugin-vue-components disabled */import { render } from "./comp2.vue?vue&type=template&id=83a664a6&scoped=true"
import script from "./comp2.vue?vue&type=script&lang=js"
export * from "./comp2.vue?vue&type=script&lang=js"

import "./comp2.vue?vue&type=style&index=0&id=83a664a6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a664a6"]])

export default __exports__